// Grandham tree data and labels for exam details pages
import TransliteratedInput from '../components/TransliteratedInput';

const krishnaYajurvedaTreeData = {
  telugu: {
    'బ్రాహ్మణము': {
      'ప్రథమాష్టకము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయాష్టకము': [1, 2, 3, 4, 5, 6, 7, 8],
      'తృతీయాష్ఠకము': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },
    'ఆరణ్యకభాగము': {
      'main': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      'ఏకాగ్ని కాండము': [1, 2],
    },
    'సంహితా': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'పదము': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'క్రమము': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'జటా': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    },
    'ఘనము': {
      'ప్రథమకాండము': [1, 2, 3, 4, 5, 6, 7, 8],
      'ద్వితీయకాండము': [1, 2, 3, 4, 5, 6],
      'తృతీయకాండము': [1, 2, 3, 4, 5],
      'చతుర్థకాండము': [1, 2, 3, 4, 5, 6, 7],
      'పంచమకాండము': [1, 2, 3, 4, 5, 6, 7],
      'షష్ఠకాండము': [1, 2, 3, 4, 5, 6],
      'సప్తమకాండము': [1, 2, 3, 4, 5]
    }
  },
  sanskrit: {
    'ब्राह्मणम्': {
      'प्रथमाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'तृतीयाष्टकम्': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    },
    'आरण्यकभागः': {
      'main': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      'एकाग्नि काण्डम्': [1, 2],
    },
    'संहिता': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'पदम्': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'क्रमम्': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'जटा': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    },
    'घनम्': {
      'प्रथमकाण्डम्': [1, 2, 3, 4, 5, 6, 7, 8],
      'द्वितीयकाण्डम्': [1, 2, 3, 4, 5, 6],
      'तृतीयकाण्डम्': [1, 2, 3, 4, 5],
      'चतुर्थकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'पञ्चमकाण्डम्': [1, 2, 3, 4, 5, 6, 7],
      'षष्ठकाण्डम्': [1, 2, 3, 4, 5, 6],
      'सप्तमकाण्डम्': [1, 2, 3, 4, 5]
    }
  }
};

const grandhamLabels = {
  telugu: {
    pannamu: 'వ ప్రశ్న',
    adhyayam: 'వ అధ్యాయం',
    prakaranam: 'వ ప్రకరణం',
    accordionTitle: 'పూర్వము(పాత) మరియు ప్రస్తుతము (క్రొత్త) పరీక్ష గ్రంథ వివరములు',
    presentTitle: 'ప్రస్తుతము (క్రొత్త) పరీక్ష ఇవ్వబోవు గ్రంథ వివరము',
    previousTitle: 'సంస్థలో పూర్వము (పాత) పరీక్ష ఇచ్చిన గ్రంథ వివరము',
    padamu: 'పదము',
    kramamu: 'క్రమము',
    jata: 'జటా',
    ghanamu: 'ఘనము',
    ashtakam: 'అష్టకము',
    kandam: 'కాండము'
  },
  sanskrit: {
    pannamu: ' प्रश्नः',
    adhyayam: ' अध्यायः',
    prakaranam: ' प्रकरणम्',
    accordionTitle: 'पूर्व/वर्तमान परीक्षा ग्रन्थविवरणानि',
    presentTitle: 'वर्तमानपरीक्षायाः ग्रन्थविवरणम्',
    previousTitle: 'संस्थायां पूर्वपरीक्षायाः ग्रन्थविवरणम्',
    padamu: 'पदम्',
    kramamu: 'क्रमम्',
    jata: 'जटा',
    ghanamu: 'घनम्',
    ashtakam: 'अष्टकम्',
    kandam: 'काण्डम्'
  }
};

// Mapping of grandham type keys to their display labels
const grandhamTypeLabels = {
  telugu: {
    'బ్రాహ్మణము': 'బ్రాహ్మణము',
    'ఆరణ్యకభాగము': 'ఆరణ్యకభాగము',
    'సంహితా': 'సంహితా',
    'పదము': 'పదము',
    'క్రమము': 'క్రమము',
    'జటా': 'జటా',
    'ఘనము': 'ఘనము'
  },
  sanskrit: {
    'ब्राह्मणम्': 'ब्राह्मणम्',
    'आरण्यकभागः': 'आरण्यकभागः',
    'संहिता': 'संहिता',
    'पदम्': 'पदम्',
    'क्रमम्': 'क्रमम्',
    'जटा': 'जटा',
    'घनम्': 'घनम्'
  }
};

// Export functions for use in other components
export const getGrandhamTreeData = (parikshaType) => {
  switch (parikshaType) {
    case 'krishna_yajurveda':
      return krishnaYajurvedaTreeData;
    default:
      return krishnaYajurvedaTreeData;
  }
};

// Define LocalizedInput outside VatuForm to prevent recreation on every render
export function LocalizedInput({ value, setValue, labels, placeholders, multiline, minRows, lang, onFocus, onBlur, disabled = false }) {
  const label = lang === 'telugu' ? labels.telugu : labels.sanskrit;
  const placeholder = placeholders ? (lang === 'telugu' ? placeholders.telugu : placeholders.sanskrit) : undefined;
  return (
    <TransliteratedInput 
      label={label} 
      value={value} 
      onChange={setValue}
      onSuggestionSelect={setValue}
      placeholder={placeholder}
      targetScript={lang === 'telugu' ? 'telugu' : 'devanagari'}
      multiline={multiline}
      minRows={minRows}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
}

export { grandhamLabels, krishnaYajurvedaTreeData, grandhamTypeLabels };
